<div class="pt-3" *ngIf="notFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!notFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-3 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <div class="m-4" *ngIf="isLoading()">
      <h3 class="text-muted">Loading...</h3>
    </div>

    <div class="m-4" *ngIf="!notFound && (serverError === null) && !isLoading()">

      <div class="form-group">
        <label for="nameInput">Roster Name</label>
        <input type="text" class="form-control"
               id="nameInput"
               name="name"
               required
               [(ngModel)]="roster.name">
        <div class="form-text text-danger">
          {{ errors.name }}
        </div>
      </div>

      <div class="form-group">
        <label for="locationSelect">Location</label>
        <select class="custom-select"
                id="locationSelect"
                name="location"
                [(ngModel)]="roster.location_id"
                [disabled]="isLoading() || !isNewRoster"
                [class.disabled]="isLoading() || !isNewRoster">
          <option *ngFor="let location of getAllowedLocations()"
                  [ngValue]="location.id">
            {{ location.name }}
          </option>
        </select>
        <small class="form-text text-muted">
          This location determines where the roster membership payments are credited, and is the default location for the roster's events. It may not be changed after the roster is created.
          <ng-container *ngIf="eventType && eventType.has_limited_location_availability">
            <br>
            This event type is restricted to specific locations.
          </ng-container>
        </small>
        <div class="form-text text-danger">{{ errors.location_id }}</div>
      </div>

      <div class="form-group">
        <label>Capacity</label>
        <div class="row">
          <div class="col-6">
            <input type="number" class="form-control" name="capacity"
                   min="1" max="1000" step="1"
                   [(ngModel)]="roster.capacity">
          </div>
        </div>
        <div class="form-text text-danger">
          {{ errors.capacity }}
        </div>
      </div>

      <div class="form-group">
        <label for="order_number">Order Number</label>
        <div class="row">
          <div class="col-lg-6 col-md-8">
            <input id="order_number"
                   name="order_number"
                   class="form-control"
                   type="number"
                   step="1"
                   [(ngModel)]="roster.order_number">
          </div>
        </div>
        <small class="form-text text-muted">
          This determines the order that rosters are displayed in the Climber App. Lower numbers are displayed first. If two rosters have the same order number, they will be displayed in alphabetical order.
        </small>
        <div class="form-text text-danger">{{ errors.order_number }}</div>
      </div>

      <div class="alert alert-info" *ngIf="!isNewRoster && (previousCapacity != roster.capacity)">
        The new capacity may take up to 15 minutes to sync to the roster's future events.
      </div>

      <div class="alert alert-danger" role="alert"
           *ngIf="errors.non_field_errors">
        {{ errors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert"
           *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="alert alert-info" role="alert"
           *ngIf="loadingSave">
        Saving...
      </div>

      <button class="btn btn-primary float-right"
              [disabled]="isLoading()" [class.disabled]="isLoading()"
              (click)="save()">
        Save Roster
      </button>

      <a class="btn btn-secondary"
              [routerLink]="'/events/setup/edit/' + eventType?.id + '/rosters'">
        Cancel
      </a>

    </div>

  </div>
</div>
